import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api";
import { BulkUpdateData } from "../../types/bulkUpdate";


export const validateCertConnectBulkUpload = createAsyncThunk<
  BulkUpdateData,          
  {orgId: string, CCOId: Array<string>},           
  { rejectValue: string }    
>(
  "certConnect/validate-certConnect-list",
  async ( {orgId, CCOId}, { rejectWithValue }) => {
    try {
      const response = await api.post(`certWatch/bulk-upload?orgId=${orgId}`, 
        CCOId
      );

      if (response.data.Data) {
        return response.data;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const RequestCertConnectBulkUpload = createAsyncThunk<
  BulkUpdateData,          
  {orgId: string, CCOId: Array<string>},           
  { rejectValue: string }    
>(
  "certConnect/request-certConnect-bulk-upload",
  async ( {orgId, CCOId}, { rejectWithValue }) => {
    try {
   const response = await api.post(`certWatch/bulk-create-cert-connect?orgId=${orgId}`, 
        CCOId
      );
      if (response.data.Data) {
        return response.data;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


